module.exports = "/shifts/components/calendarHeader/employeeHeaderWeek-ccb773.html";